

























import Vue from 'vue';
import axios, {AxiosError} from "axios"

export default Vue.extend({
  name: 'Home',
  components: {},
  data: function () {
    return {
      email: "" as string,
      loading: false as boolean,
      validEmail: false as boolean
    }
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key == "Enter" && this.validEmail) {
        this.submit()
      }
    })
  },
  methods: {
    onValueChanged() {
      const atSplit = this.email.split("@")
      this.validEmail = (atSplit.length == 2 && atSplit[1].split(".").length == 2);
    },
    submit() {
      const data = {"email": this.email}
      console.log("axios:" + JSON.stringify(data))
      this.loading = true
      axios
          .post('/api/mail/add', data)
          .then(response => (
              this.response()
          )).catch(error => (
          this.error(error)
      ))
    },

    response() {
      this.loading = false
      this.email = ""
      this.$buefy.toast.open({
        duration: 3000,
        message: 'Successfully added to the mailing list.',
        position: 'is-bottom-right',
        type: 'is-success',
      })
    },
    error(error: AxiosError) {
      this.loading = false
      this.$buefy.toast.open({
        duration: 3000,
        message: 'Something went wrong. Please try again or contact us.',
        position: 'is-bottom-right',
        type: 'is-danger',
      })
    }
  }
});
